export enum AssignmentRequestStatus {
  Initialed = 'Initialed',
  Rejected = 'Rejected',
  Approved = 'Approved',
}
